module.exports = __webpack_public_path__ + "static/media/ESN_SGGW_background.1d1650f9.png";